import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { MomentModule } from 'ngx-moment';

import { coerceToTimestamp } from './coerce';

@Component({
  selector: 'rt-assistant-cell-datetime',
  imports: [MomentModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `{{ time() | amDateFormat: 'lll' }}`,
})
export class AssistantCellDatetimeComponent {
  public static readonly NgInputs = [<const>'value'];

  protected readonly time = computed(() => coerceToTimestamp(this.value()));

  public readonly value = input<unknown>();
}
